import axios, { type AxiosResponse } from 'axios'

import type {
    AddReportPalletPayloadSchema,
    AddReportPalletResponseSchema,
    CheckPalletParameterResponseSchema,
    PaperReportDetailResponseSchema
} from '@/api/schemas/reports/paperReporting'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'

class PaperReportingQueries {
    getPaperReport(reportId: number | string): Promise<AxiosResponse<PaperReportDetailResponseSchema>> {
        return axios.get<PaperReportDetailResponseSchema>(`${API_ENDPOINTS.REPORTS.PAPER.PAPER_REPORTS}/${reportId}`)
    }

    checkPalletParameter(parameter: string): Promise<AxiosResponse<CheckPalletParameterResponseSchema>> {
        return axios.post<CheckPalletParameterResponseSchema>(API_ENDPOINTS.REPORTS.PAPER.CHECK_PALLET_PARAMETER, {
            parameter
        })
    }

    addPallet(payload: AddReportPalletPayloadSchema): Promise<AxiosResponse<AddReportPalletResponseSchema>> {
        return axios.post<AddReportPalletResponseSchema>(API_ENDPOINTS.REPORTS.PAPER.REPORT_PALLETS, payload)
    }

    removePallet(reportPalletId: number | string): Promise<AxiosResponse<unknown>> {
        return axios.delete<unknown>(`${API_ENDPOINTS.REPORTS.PAPER.REPORT_PALLETS}/${reportPalletId}`)
    }
}

export default new PaperReportingQueries()
